import {Injectable, inject} from "@angular/core";
// environment
import {environment} from "@environments/environment";
// services
import {StateManagementService} from "./state-management.service";
import {getMessaging, getToken, onMessage} from "firebase/messaging";
import {StorageService} from "@app/shared/services/storage.service";

@Injectable()
export class FirebaseService {
  private id: string;

  // dependencies
  private _stateManagementService = inject(StateManagementService);
  private _storageService = inject(StorageService);

  constructor() {}

  // initial firebase
  public requestPermission(app: any) {
    const messaging = getMessaging(app);
    getToken(messaging, {vapidKey: environment.firebase.vapidKey})
      .then((currentToken) => {
        if (currentToken) {
          this._storageService.setFirebaseToken(currentToken);
          this.createFirebase(currentToken);
        } else {
          console.log(
            "No registration token available. Request permission to generate one."
          );
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
      });
  }

  public listen(app: any) {
    const messaging = getMessaging(app);
    onMessage(messaging, (payload) => {
      console.log("Message received. ", payload);
    });
  }

  public createFirebase(firebase_token: string) {
    // this.id = data.createFirebase.id;
    // this._stateManagementService.firebaseData$.next(data);
  }

  public removeFirebase() {
    const firebaseToken = this._storageService.getFirebaseToken();
  }
}
